exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.color-red {\n  color: #eb1c23;\n}\n.title {\n  border-bottom: solid 2px #ccc;\n  padding: 5px;\n}\n.overflow-hidden {\n  overflow: hidden;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a4eec83","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/component/aboutUs.vue
// module id = 330
// module chunks = 0